<template>
    <form action="/carparks" method="post" :class="{ disabled : isAvailable }">
        <input type="hidden" name="_token" :value="csrf">
        <div :class="'bg-' + bgColor" class="py-2 text-center text-white text-xl lg:text-2xl p-3">
            <img :src="logo" alt="Carpark logo" class="mx-auto">
        </div>
        <div :class="isAvailable ? 'bg-' + bgColor : 'bg-gray-700'" class="pb-8 pl-8 pr-8 pt-2">
            <div v-if="isAvailable">
                <div class="text-center text-4xl font-bold py-2" :class="'text-' + primaryColor">
                    From {{ $filters.money(currentBookingPrices.car.price) }}
                </div>

                <div class="text-center mt-1 block w-full sm:w-3/5 mx-auto">
                    <button type="submit" :class="'text-' + bgColor"
                        class="w-full py-2 text-3xl font-bold uppercase rounded-md tracking-widest bg-white shadow-white drop-shadow-xl">
                        Lets Book Now
                    </button>
                </div>

                <div class="text-md text-white text-center mt-4">
                    <div class="block text-lg">
                        <span class="text-md inline-block"><i
                                class="fas fa-tachometer-alt fs-xs align-text-top"></i></span>
                        5-10 min transfer
                    </div>

                    <div class="block text-lg">
                        <span class="text-md"><i class="fas fa-bus fs-xs"></i></span>
                        {{ carpark.transfer_information }}
                    </div>
                </div>
            </div>
            <div class="text-2xl text-red-600 text-center py-16" v-else>
                <p>SORRY WE ARE SOLD OUT</p>
            </div>

            <div class="text-sm text-white text-center mt-6">
                <span class="font-bold text-center block tracking-wider mb-1">{{ carpark.name }}</span>
                <span class="block">{{ carpark.description }}</span>

                <button @click="showMapModal = true" type="button" class="capitalize mt-4 text-white">
                    <svg class="w-4 h-4 inline-block mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                        </path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    View Map &amp; Directions
                </button>
            </div>
        </div>
        <input type="hidden" name="carpark" :value="carpark.id">
        <input type="hidden" name="entry" :value="entry">
        <input type="hidden" name="exit" :value="exit">
    </form>

    <MapDirectionsModal :is-open="showMapModal" @close="showMapModal = false"></MapDirectionsModal>
</template>

<script>
import MapDirectionsModal from './MapDirectionsModal.vue';

export default {
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            showMapModal: false,
            showVehicleInformationModal: false,
        };
    },
    props: {
        carpark: { required: true },
        entry: { required: true },
        exit: { required: true },
        currentBookingPrices: { required: true },
        logo: { required: true },
        bgColor: { required: true },
        primaryColor: { required: true },
    },
    computed: {
        isAvailable() {
            return this.currentBookingPrices !== null;
        },
    },
    components: {
        MapDirectionsModal,
    },
};
</script>
